var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"availability_days mb-6"},[_c('card-title',{attrs:{"title":'Jour(s) de disponibilité en téléconsultation',"icon":'mdi-calendar-check'}}),(_vm.doctor)?_c('horaire-form',{attrs:{"horaire":_vm.doctor.horaire_teleconsultation},on:{"saveHoraire":_vm.saveHoraire}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }